
import Navbar from './AllRoutes/Navbar';
import Routess from './AllRoutes/Routess';
import './App.css';
import Fotter from './Pages/Fotter';
import Home from './Pages/Home';

function App() {
  return (
    <div >
      <Home/>
     <Navbar/>
     <Routess/>
    
    </div>
  );
}

export default App;
